import { questionnaireGql } from '../../../gql-gen/questionnaire'

export const SET_ENTRIES_HIDDEN = questionnaireGql(/* GraphQL */ `
  mutation setEntriesHiddenV2($input: SetEntriesHiddenV2Input!) {
    setEntriesHiddenV2(input: $input) {
      ...DraftQuestionnaireEntry
    }
  }
`)
